import { render, staticRenderFns } from "./ClientBonitaForm.vue?vue&type=template&id=7be4856c&scoped=true&"
import script from "./ClientBonitaForm.vue?vue&type=script&lang=js&"
export * from "./ClientBonitaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be4856c",
  null
  
)

export default component.exports